













import {Component, Prop, Vue} from 'vue-property-decorator'
import {IServiceTypePrice} from '@/entities/service-type-price'
import {Theme} from "@/store";

@Component
export default class ServicePrice extends Vue {

  @Prop() readonly data!: IServiceTypePrice
  @Prop({ default: false }) readonly large?: boolean
  @Prop({ default: false }) readonly withCategoryLabel?: boolean
  @Prop() readonly theme?: Theme

  get categoryLabel(): string {
    let category = this.data.category;
    return category ? (category.toUpperCase() + ' ' + this.$t('categories.' + category + '.name')) : '';
  }

  get price(): string {
    return this.$storage.getters.getPriceLabel(this.data?.price as number | string);
  }

  get showCategoryLabel(): boolean {
    return !!(this.withCategoryLabel && this.data.category);
  }

}
